/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".body-wrapper[_ngcontent-%COMP%]{position:relative;top:-20px}.content-area[_ngcontent-%COMP%]{min-height:70vh}"];
export { styles as styles };
